import { ActionTree } from 'vuex';
import { EDeletePageAction, EDeletePageMutation, getDefaultState } from './delete-page.constants';
import { IDeletePageState } from './delete-page.types';
import { RootState } from '@/store/store';
import { DocumentService } from '@/api/documents/services/document.service';
import { translate } from '@/helpers/translation.helper';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';
import { IDocumentPage } from '@lib-shared/types/document-page';
import { ResourceService } from '@/api/resources/services/resource.service';

export const actions: ActionTree<IDeletePageState, RootState> = {
  [EDeletePageAction.Reset]({ commit }) {
    commit(EDeletePageMutation.SetState, getDefaultState());
  },
  async [EDeletePageAction.Delete](
    { commit, dispatch },
    { documentId, page }: { documentId: string; page: IDocumentPage }
  ) {
    commit(EDeletePageMutation.SetDeletedPageId, getDefaultState().deletedPageId);
    commit(EDeletePageMutation.SetDeleting, true);
    commit(EDeletePageMutation.SetDeleteFailed, false);
    commit(EDeletePageMutation.SetPageToBeDeleted, page);

    try {
      const deleted: boolean = await DocumentService.deletePage(documentId, page.id);
      if (!deleted) {
        dispatch(EDeletePageAction.DeleteFailed);
        return;
      }
      if (page.resourceId) {
        await ResourceService.disconnect({ documentId, resourceId: page.resourceId });
      }
      dispatch(EDeletePageAction.DeleteSuccess, page.id);
    } catch {
      dispatch(EDeletePageAction.DeleteFailed);
    }
  },
  [EDeletePageAction.DeleteSuccess]({ commit }, pageId: string) {
    commit(EDeletePageMutation.SetDeletedPageId, pageId);
    commit(EDeletePageMutation.SetDeleting, false);
  },
  [EDeletePageAction.DeleteFailed]({ commit, dispatch }) {
    dispatch(
      `${alertNamespace}/${EAlertAction.ShowDanger}`,
      translate('failed-to-remove-document-page'),
      {
        root: true,
      }
    );
    commit(EDeletePageMutation.SetDeletedPageId, { ...getDefaultState() }.deletedPageId);
    commit(EDeletePageMutation.SetDeleting, false);
    commit(EDeletePageMutation.SetDeleteFailed, true);
  },
};
